import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { MenuFabItem } from "../../../interfaces/menu-fab-item";
import { MatTooltip } from "@angular/material/tooltip";

import { MatIcon } from "@angular/material/icon";
import { MatButton, MatFabButton } from "@angular/material/button";

@Component({
	selector: "app-menu-fab",
	templateUrl: "./menu-fab.component.html",
	styleUrls: ["./menu-fab.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatButton, MatFabButton, MatIcon, MatTooltip],
})
export class MenuFABComponent {
	@Input() fabButtons: MenuFabItem[] = [];
	@Output() itemClickChange = new EventEmitter<string>();
	isOpen = false;

	onToggleFab(): void {
		this.isOpen = !this.isOpen;
	}

	callItemFn(fn: string) {
		this.itemClickChange.emit(fn);
		this.isOpen = false;
	}
}
